<template>
 <div :class="classObj" class="app-wrapper">
  <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
  <sidebar class="sidebar-container" />
  <div class="main-container">
   <div :class="{ 'fixed-header': fixedHeader }">
    <navbar />
   </div>
   <app-main />
  </div>

  <div class="dk-container global-progress" :class="{ 'is-collpase': $store.state.boarddata.global_collapse }">
   <div class="dk-container collapse-button" @click="handleClick_collapse">☺</div>
   <div >
    <el-input 
      style="margin-top: 1px;margin-bottom: 1px;" 
      v-model="search_name"
      clearable
      placeholder="搜索主板名称"></el-input>
  </div>
   <div class="dk-container content">
    <el-table :data="filterBoard" stripe>
     <el-table-column prop="name" :label="generateTitle('p99_sdb_tt_bd')" header-align="center" width="140"> </el-table-column>
     <el-table-column prop="" :label="generateTitle('p99_sdb_tt_pgs')" header-align="center" width="150">
      <template slot-scope="scope">
       <el-progress :percentage="scope.row._progress"></el-progress>
      </template>
     </el-table-column>
    </el-table>
   </div>
  </div>
 </div>
</template>

<script>
import { filter } from 'lodash';
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { getThmUpdProgress, getUserAllBoard, getBoardRTInfo, sceneSkip, getBoardSubDevInfo, setBoardSubDevOperate, boardReset } from '@/api/board'
import { generateTitle } from '@/utils/i18n'

var _this

export default {
 name: 'Layout',

 components: {
  Navbar,
  Sidebar,
  AppMain,
 },

 mixins: [ResizeMixin],

 computed: {
  sidebar() {
   return this.$store.state.app.sidebar
  },
  device() {
   return this.$store.state.app.device
  },
  fixedHeader() {
   return this.$store.state.settings.fixedHeader
  },
  classObj() {
   return {
    hideSidebar: !this.sidebar.opened,
    openSidebar: this.sidebar.opened,
    withoutAnimation: this.sidebar.withoutAnimation,
    mobile: this.device === 'mobile',
   }
  },
  filterBoard() {
    if (_.isNil(this.search_name) || this.search_name === '') {
      return this.board_store
    }
    return filter(this.board_store, (o) => {
      return o.name.includes(this.search_name)
    })
  },
 },

 watch: {
  '$store.state.boarddata.filer_board_name'(newVal, oldVal) {
    console.log('filer_board_name', oldVal, newVal)
    this.search_name = newVal
  },
  '$store.state.boarddata.global_collapse'(newVal, oldVal) {
   if (this.$store.state.boarddata.global_collapse) {
    console.log('stop mon')
    this.shutdownMonitorProgress()
   } else {
    console.log('start mon', this.$store.state.boarddata)
    this.search_name = this.$store.state.boarddata.filer_board_name
    this.triggerMonitorProgress()
   }
  },
 },

 beforeCreate() {},

 mounted() {
  _this = this

  getUserAllBoard(this.$store.getters.openid).then(response => {
   //     chip_uid: "2a0021001051383438373634"
   // guid: "24f5bcbe37f18bdcaa23bd5140d6193a"
   // name: "大连宿舍"
   this.board_store = response.data

   // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  })
 },

 methods: {
  generateTitle,
  triggerMonitorProgress() {
   // this.board_store.forEach((eleBoard, idxBoard, arrBoard) => {
    this.filterBoard.forEach((eleBoard, idxBoard, arrBoard) => {
    eleBoard._monitor_counter = 60 * 5
    eleBoard._interval_handler = setInterval(() => {
     getThmUpdProgress(eleBoard.guid)
      .then(response => {
       eleBoard._monitor_counter--
       _this.$set(eleBoard, '_progress', response.data)

       if (eleBoard._monitor_counter < 1 ) {
        clearInterval(eleBoard._interval_handler)
       }

       if (eleBoard._progress === 100) {
        console.log('stop mon')
        _this.shutdownMonitorProgress()
        this.$store.dispatch('boarddata/setGlobalCollapse', true)
        this.$message({
         message: '下载完成',
         type: 'success',
        })

       }
      })
      .catch(error => {
        this.handleClickOutside()
       clearInterval(eleBoard._interval_handler)
      })
    }, 1000)
   })
  },

  shutdownMonitorProgress() {
   this.board_store.forEach((eleBoard, idxBoard, arrBoard) => {
    clearInterval(eleBoard._interval_handler)
   })
  },

  handleClick_collapse() {
   this.$store.state.boarddata.global_collapse = !this.$store.state.boarddata.global_collapse
  },

  handleClickOutside() {
   this.$store.dispatch('app/closeSideBar', {
    withoutAnimation: false,
   })
  },
 },

 data() {
  return {
   interval_handler: [],
   board_store: [],
   search_name: '',
  }
 },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
 @include clearfix;
 position: relative;
 height: 100%;
 width: 100%;
 overflow: hidden;

 &.mobile.openSidebar {
  position: fixed;
  top: 0;
 }

 $width_global-progress: 300px;
 $height_global-progress: 600px;

 .global-progress {
  // border: solid 3px rgb(147, 147, 255);
  border-top: solid 3px rgb(147, 147, 255);
  border-left: solid 3px rgb(147, 147, 255);
  box-shadow: -5px -5px 10px #04223365;

  @include setWidthHeight(($width_global-progress), ($height_global-progress));
  background-color: rgba(255, 0, 0, 0.3);
  position: absolute;
  bottom: 0px;
  right: 0px;
  transition: all 0.3s;
  // pointer-events: none;
  z-index: 11;

  $width_collapse-button: 15px;
  $height_collapse-button: 60px;

  .collapse-button {
   @include setWidthHeight(($width_collapse-button), ($height_collapse-button));
   @include setFlexAlign((column), (nowrap), (center), (center));
   color: white;
   background-color: rgb(147, 147, 255);
   position: absolute;
   top: -3px;
   left: -($width_collapse-button);
   border-top-left-radius: 7px;
   border-bottom-left-radius: 7px;
   cursor: pointer;
   pointer-events: all;
  }

  .content {
   transition: all 0.3s;
   @include setWidthHeight((100%), (100%));

   .el-table {
    @include setWidthHeight((100%), (100%));

    $height_el-table__header-wrapper: 50px;

    ::v-deep .el-table__header-wrapper {
     @include setHeight($height_el-table__header-wrapper);
    }
    ::v-deep .el-table__body-wrapper {
     @include setHeight(calc(100% - #{$height_el-table__header-wrapper}));
     overflow: auto;

     ::v-deep .el-table__body {
      ::v-deep .el-table__row {
       td {
        padding: 5px;
        margin: 0;

        ::v-deep .cell {
         @include setFlexAlign((row), (nowrap), (center), (center));

         white-space: nowrap;
         text-overflow: ellipsis;
         overflow: hidden;
        }
       }
      }
     }
    }

    ::v-deep .el-progress {
     @include setWidthHeight((100%), (100%));
    }
   }
  }
 }

 .global-progress.is-collpase {
  // (calc(100% - #{$XXXXXXX})) (100px)
  // @include setWidth(0px);
  transform: translate($width_global-progress, 0);

  // display: none;
 }
}

.drawer-bg {
 background: #000;
 opacity: 0.3;
 width: 100%;
 top: 0;
 height: 100%;
 position: absolute;
 z-index: 999;
}

.fixed-header {
 position: fixed;
 top: 0;
 right: 0;
 z-index: 9;
 width: calc(100% - #{$sideBarWidth});
 transition: width 0.28s;
}

.hideSidebar .fixed-header {
 width: calc(100% - 54px);
}

.mobile .fixed-header {
 width: 100%;
}
</style>
